export default __webpack_public_path__ + "static/media/keg-us-30.45a94b9c.png";